// How feeds are ordered. Shown to people in plain words under "Why these posts?".
export type Rankable = { createdAt: number; reactions: number; comments: number; saves: number };

const HOUR = 3_600_000;
/** Trending: people remembering, commenting and saving, weighted towards newer posts. */
export function trendingScore(p: Rankable, now: number): number {
  const ageHours = Math.max(0, (now - p.createdAt) / HOUR);
  return (p.reactions + 2 * p.comments + 1.5 * p.saves + 1) / Math.pow(ageHours + 2, 1.3);
}
export const RANKING_EXPLAINED =
  'Trending mixes how many people remember a memory, comment on it and save it, and how new it is. ' +
  'Following shows only people, years, tags and communities you follow, newest first. Latest is plain time order.';
